export function intToDuration(seconds: number, highestOnly = false): string {
    const duration: string[] = [];

    const add = (unit: string, value: number) => {
        if (value && (!highestOnly || (highestOnly && !duration.length))) {
            if (highestOnly && unit !== 'seconds') {
                value = value + 1;
            }

            duration.push(`${value} ${unit}`);
        }
    };
    // DD-4E5F Doing some juggling to go from 2 minutes to 90 seconds and lower (only in highestonly mode)
    const m = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
    const s = (((seconds % 31536000) % 86400) % 3600) % 60;

    add('years', Math.floor(seconds / 31536000));
    add('days', Math.floor((seconds % 31536000) / 86400));
    add('hours', Math.floor(((seconds % 31536000) % 86400) / 3600));
    add('minutes', m === 1 && s <= 30 && highestOnly ? m - 1 : m);
    add('seconds', m === 1 && s <= 30 && highestOnly ? s + 60 : s);

    let str = '';
    for (let i = 0; i < duration.length; i++) {
        if (i === 0) {
            str += `${duration[i]}`;
        } else if (i > 0 && i < duration.length - 1) {
            str += `, ${duration[i]}`;
        } else if (i === duration.length - 1) {
            str += ` and ${duration[i]}`;
        }
    }
    return str;
}
